const Header = () => (
    <header style={{ textAlign: 'center', padding: '10px', background: '#f8f9fa' }}>
      <h1>Mental Tracker</h1>
    </header>
  );
  
  export default Header;
  